<template>
 <div
    v-if="showLoadingState || $store.getters.getAcademyLoadingSubmenu"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
  >
  <div
    key="academyUserProfile"
    class="m-edition-academy-users-profile"
  >
    <div class="m-card-primary profile-info">
      <div class="display-flex-row-center profile-info-user-profile-sales">
        <AtomAvatarSecondary
          avatar-class="xlarge profile-info-user-avatar"
          :user-image="perfil.usuario.avatar"
        />
        <span class="display-flex-column font-weight-light justify-content-center">
          <span
            v-if="perfil.usuario.persona && perfil.usuario.persona.razon_social"
            class="font-size-large"
          >
            <b>{{ perfil.usuario.persona.razon_social }}</b>
          </span>
          <span :class="getUserGlobalState()">
            {{ perfil.usuario.email }}
          </span>
        </span>
      </div>
     </div>
  </div>
      <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="compras.length">
          <th
            class="text-align-right"
            width="15%"
          >
            {{ $t('mEditionAcademyUsersProfileSales.table.thTotal') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionAcademyUsersProfileSales.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
             {{ $t('mEditionAcademyUsersProfileSales.table.thDiscount') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionAcademyUsersProfileSales.table.thMethod') }}
          </th>
          <th
            class="text-align-left"
            width="14%"
          >
             {{ $t('mEditionAcademyUsersProfileSales.table.thConcept') }}
          </th>
          <th
            class="text-align-left"
            width="16%"
          >
             {{ $t('mEditionAcademyUsersProfileSales.table.thClient') }}
          </th>
          <th
            class="text-align-center"
            width="11%"
          >
             {{ $t('mEditionAcademyUsersProfileSales.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
             {{ $t('mEditionAcademyUsersProfileSales.table.thRecord') }}
          </th>
        </tr>
        <tr
          v-for="(compra, index) in compras"
          :key="index"
          class="row-data"
        >
          <td class="text-align-right text-white-space-nowrap">
            <span
              v-if="compra.total || compra.precio"
            >
              <span>{{ compra.divisa }} {{ compra.total.toFixed(2) }}</span>
              <span class="text-color-black-35"> {{ compra.divisa_iso_code }}</span><br>
              <small :class="$filters.getSaleStateValue(compra.compra_estado, 'class')">
                {{ $filters.getSaleStateValue(compra.compra_estado, 'name') }}
              </small>
            </span>
            <span
             v-else
            >
              <span>{{ $t('mEditionAcademyUsersProfileSales.free') }}</span><br>
              <small :class="$filters.getSaleStateValue(compra.compra_estado, 'class')">
                {{ $filters.getSaleStateValue(compra.compra_estado, 'name') }}
              </small>
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(compra.fecha_compra).format('D MMM YYYY') }}
          </td>
            <td class="ellipsis text-align-center">
            <span
              v-if="compra.cupon_codigo"
              :key="`${index}-${compra.cupon_codigo}`"
            >
              {{ compra.cupon_codigo }}
            </span>
            <span
              v-else
              :key="`${index}-nodiscount`"
            >
              -
            </span>
          </td>
          <td class="text-align-center">
            <span v-if="compra.medio_pago">
              {{ compra.medio_pago }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="break-word text-align-left">
            {{ compra.concepto }}
          </td>
          <td class="break-word text-align-left">
            <span class="display-flex-column">
              <span>{{ compra.nombre_cliente }}</span>
              <small class="ellipsis font-weight-regular text-color-black-35">
                {{ compra.email_cliente }}
              </small>
            </span>
          </td>
          <td class="text-align-center">
           {{
              compra.total || compra.precio
                ? $utils.getPaymentFrequency(compra.pago_cuotas, compra.pago_frecuencia, compra.pago_intervalo)
                : '-'
            }}
          </td>
          <td class="text-align-center">
             <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.record"
              :element="compra"
              @gotToSaleRecord="gotToSaleRecord"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyUsersProfileSales',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        record: {
          class: 'a-button-secondary a-button-academy-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToSaleRecord',
          tooltip: 'Ver Compra',
          type: 'button'
        }
      },

      compras: {},

      filter: {
        limite: 10,
        pagina: 1
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      perfil: {},

      showLoadingState: true
    }
  },

  created () {
    this.readAcademiaPerfilActor()
  },

  methods: {
    getUserGlobalState () {
      if (this.perfil.actores.find(actor => actor.habilitado === 1)) {
        return 'font-weight-bold text-color-success'
      } else {
        return 'font-weight-bold text-color-danger'
      }
    },

    gotToSaleRecord (compra) {
      this.$router.push(`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.users.subject')}/${this.$route.params.id}/${this.$t('mEditionMenu.academy.users.children.profile.subedition')}/${compra.id_compra}/${this.$t('mEditionMenu.academy.users.children.profile.children.salesRecord.subitem')}`)
    },

    readAcademiaPerfilActor () {
      console.log(this.$filters)
      this.$services.read('academia', 'readAcademiaPerfilActor', {}, [this.$store.getters.getAcademyData.id, this.$route.params.id])
        .then(response => {
          this.perfil = Object.assign({}, response.data)
          this.perfil.actores.sort((a, b) => {
            return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
          })
          this.readAlumnoCompras()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    readAlumnoCompras () {
      this.$services.read('academia', 'readAlumnoCompras', {}, [this.perfil.actores.find(a => { return a.tipo === 0 }).id, this.$store.getters.getAcademyData.id], this.filter)
        .then(response => {
          this.compras = response.data.compras
          this.pagination.currentQuantity = this.compras.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAlumnoCompras()
    }
  }

}
</script>
